import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HostService } from '../host/host.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FamilyService {
  host:string;
  public families: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public menucategories: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  constructor(
    private hostService:HostService,
    private http:HttpClient
  ) {
    this.host=this.hostService.host;
  }
  
  getFamiliesOfCarte(){
    return this.http.get(this.hostService.host+'families/cmd/carte');
  }

  getMenuCategoriesOfCarte(){
    return this.http.get(this.hostService.host+'menucategories/cmd/carte');
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/family/family.service.ts